import {
  List,
} from "@material-ui/core";
import React from "react";
import NavDrawerListItem from "../NavDrawerListItem";

const NavDrawerList = ({ data }) => {
  return (
    <div>
      <List>
        {data?.map((item) => (
          <NavDrawerListItem
            key={item.text}
            icon={item?.icon}
            text={item.text}
            url={item.url}
            color={item?.color}
            
             />
        ))}
      </List>
      
    </div>
  );
};

export default NavDrawerList;
